const WarehouseWeightType = `
  id
  name
`;

export default WarehouseWeightType;
